(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goal-stat-bars"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('goal-stat-bars')) {
    customElements.define('goal-stat-bars', class GoalStatBars extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        // Wait until the bars inside this element have been parsed (matters when several of these sections are on one page)
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || this.dataset.animate === 'false') return;

        this.duration = parseInt(this.dataset.duration, 10) || 1400;
        this.stagger = parseInt(this.dataset.stagger, 10) || 200;
        this.classList.add('is-ready');
        this.zeroNumbers();

        const inEditor = window.Shopify && window.Shopify.designMode;
        if (this.dataset.trigger === 'load' || inEditor || !('IntersectionObserver' in window)) {
          requestAnimationFrame(() => requestAnimationFrame(() => this.play()));
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play();
              if (this.dataset.replay !== 'true') this.observer.disconnect();
            } else if (this.dataset.replay === 'true') {
              this.reset();
            }
          });
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.frames && this.frames.forEach((id) => cancelAnimationFrame(id));
      }

      get nums() { return [...this.querySelectorAll('[data-num]')]; }

      zeroNumbers() {
        if (this.dataset.count === 'true') this.nums.forEach((el) => { el.textContent = '0'; });
      }

      play() {
        if (this.classList.contains('is-in')) return;
        this.classList.add('is-in');
        if (this.dataset.count === 'true') this.countUp();
      }

      reset() {
        this.classList.remove('is-in');
        this.frames && this.frames.forEach((id) => cancelAnimationFrame(id));
        this.zeroNumbers();
      }

      countUp() {
        const ease = (t) => 1 - Math.pow(1 - t, 3);
        this.frames = [];
        this.nums.forEach((el) => {
          const row = el.closest('[data-index]');
          const index = row ? parseInt(row.dataset.index, 10) || 0 : 0;
          const target = parseInt(el.dataset.to, 10) || 0;
          const startAt = performance.now() + index * this.stagger;
          const step = (now) => {
            const progress = Math.min(1, Math.max(0, (now - startAt) / this.duration));
            el.textContent = Math.round(target * ease(progress));
            if (progress < 1) this.frames.push(requestAnimationFrame(step));
          };
          this.frames.push(requestAnimationFrame(step));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
